import List from 'containers/Batch/List';

export default { List };
